@if (!redeemed) {
  @if (orientation === 'portrait') {
    <ng-container *ngTemplateOutlet="portrait; context: { $implicit: auctionItem }"></ng-container>
  } @else if (orientation === 'landscape') {
    <div class="d-none d-lg-flex">
      <ng-container *ngTemplateOutlet="landscape; context: { $implicit: auctionItem }"></ng-container>
    </div>
    <div class="d-lg-none d-flex">
      <ng-container *ngTemplateOutlet="portrait; context: { $implicit: auctionItem }"></ng-container>
    </div>
  }
} @else {
  <div class="wallet-container redeemed-border p-3 cursor-pointer">
    <div class="row">
      <div class="col-lg-1 col-2">
        <img
          class="purchase-list-image"
          [src]="auctionItem?.Image | contentImage: '7'"
          alt=""
          [useDefault]="true"
          [loyaltyType]="'marketplace'"
          draggable="false"
        />
      </div>
      <div class="col-lg-11 col-10">
        <div class="ms-lg-0 ms-3 d-flex flex-column justify-content-between h-100">
          <div class="wallet-auction-item-name">{{ auctionItem?.Name }}</div>
          @if (auctionItem.RedeemDate) {
            <div class="auction-wallet-claimed">
              {{ 'fgbcl.auction.claimed' | translate }}
              {{ auctionItem?.RedeemDate | UtcToLocaltimePipe: dateOption.ShortDateFormat }}
            </div>
          } @else if (expired()) {
            <fgbcl-expired-pill [ExpirationDate]="auctionItem.ExpireDate"></fgbcl-expired-pill>
          }
        </div>
      </div>
    </div>
  </div>
}

<!-- PORTRAIT VIEW -->
<ng-template #portrait let-item>
  <div
    class="card redeem-card py-3 bg-wallet-auction cursor-pointer"
    [ngClass]="{ redeemed: item?.RedeemDate, 'w-btn': showButton }"
  >
    <div class="d-flex justify-content-center align-items-center">
      <img
        class="purchase-list-image"
        src="{{ item?.Image | contentImage: '7' }}"
        alt=""
        [useDefault]="true"
        [loyaltyType]="'marketplace'"
        draggable="false"
      />
    </div>
    <div class="auction-wallet-won-item-name purchase-title">{{ item?.Name }}</div>

    @if (item?.RedeemDate) {
      <div class="auction-wallet-claimed">
        {{ 'fgbcl.auction.claimed' | translate }}
        {{ auctionItem?.RedeemDate | UtcToLocaltimePipe: dateOption.ShortDateFormat }}
      </div>
    } @else if (expired()) {
      <fgbcl-expired-pill [ExpirationDate]="auctionItem.ExpireDate"></fgbcl-expired-pill>
    } @else {
      <!--Expiration Date-->
      <ng-container *ngIf="item?.ExpireDate">
        <div class="wallet-item-expiry">
          {{ 'fgbcl.wallet.expiry.date' | translate }}
          {{ item.ExpireDate | UtcToLocaltimePipe: dateOption.LongDateFormat }}
        </div>
      </ng-container>
    }
    <div class="action-wrapper d-lg-flex d-none">
      <button class="bg-primary rounded marketplace-wallet-view-btn">
        <span class="font-size-14">{{ 'view.rewards.item' | translate }}</span>
      </button>
    </div>
    @if (!item?.RedeemDate) {
      <div class="d-lg-none d-flex mt-auto">
        <ng-container *fgbWebsiteContentFeatureFlag="'fgbcl.feature.flag.wallet.barcode.auction'">
          <div class="d-block d-lg-none">
            <div class="qrcode-container">
              @if (!showButton) {
                <qrcode
                  [qrdata]="item.Barcode"
                  [width]="116"
                  [errorCorrectionLevel]="'M'"
                  [elementType]="'svg'"
                  [margin]="0"
                ></qrcode>
              } @else {
                <qrcode
                  [qrdata]="item.Barcode"
                  [width]="83"
                  [errorCorrectionLevel]="'M'"
                  [elementType]="'svg'"
                  [margin]="0"
                ></qrcode>
              }
            </div>
            @if (!showButton) {
              <span class="marketplace-scan-text">{{ 'marketplace.purchased.list.item.scan.text' | translate }}</span>
            }
          </div>
        </ng-container>
        <div class="action-wrapper d-none d-lg-flex">
          <span class="marketplace-claim-text">{{ 'marketplace.purchased.list.item.claim.text' | translate }}</span>
        </div>
      </div>
    }
  </div>
</ng-template>

<!-- LANDSCAPE VIEW -->
<ng-template #landscape let-item>
  <div class="card wallet-item-card">
    <div class="wallet-item-card-details">
      <img [src]="item.Image | contentImage: '7'" alt="" [useDefault]="true" [loyaltyType]="'wallet'" draggable="false" />
      <div class="wallet-item-details">
        <div class="wallet-item-title">{{ item.Name }}</div>

        @if (item?.RedeemDate) {
          <div class="auction-wallet-claimed">
            {{ 'fgbcl.auction.claimed' | translate }}
            {{ auctionItem?.RedeemDate | UtcToLocaltimePipe: dateOption.ShortDateFormat }}
          </div>
        } @else if (expired()) {
          <fgbcl-expired-pill [ExpirationDate]="auctionItem.ExpireDate"></fgbcl-expired-pill>
        } @else {
          <!--Expiration Date-->
          <ng-container *ngIf="item?.ExpireDate">
            <div class="wallet-item-expiry">
              {{ 'fgbcl.wallet.expiry.date' | translate }}
              {{ item.ExpireDate | UtcToLocaltimePipe: dateOption.LongDateFormat }}
            </div>
          </ng-container>
        }
      </div>
    </div>
    <div class="action-buttons" *ngIf="!item?.RedeemDate && !expired()">
      <span class="marketplace-claim-text">{{ 'marketplace.purchased.list.item.claim.text' | translate }}</span>
    </div>
  </div>
</ng-template>
